<style src="./ColumnHeader.scss" lang="scss"></style>
<template>
  <tr class="column-header">
    <th scope="row" class="header id">ITEM</th>
    <th class="header strict" title="Exclusivo para ME"></th>
    <th class="header guaranted" title="Produto com garantia de preço"></th>
    <th class="header product">
      <span class="htitle">PRODUTO</span>
    </th>
    <th class="header qt">
      <span class="htitle">UNID</span>
    </th>
    <th class="header qt">
      <span class="htitle">QT</span>
    </th>

    <!-- COST -->
    <th
      @click="toggleColumnView('costLab')"
      :class="{ 'lab__contracted': headerView.contracted.costLab }"
      class="header lab"> <!-- COST -->
      <span class="title lab">MARCA</span>
    </th>
    <th
      @click="toggleColumnView('costUnit')"
      :class="{ 'unit__contracted': headerView.contracted.costUnit }"
      class="header unit">
      <span class="title unit">V. UNIT</span>
    </th>
    <th
      @click="toggleColumnView('costTotal')"
      :class="{ 'total__contracted': headerView.contracted.costTotal }"
      class="header total separator">
      <span class="title total">V. TOTAL</span>
    </th>

    <!-- MAX PRICE -->
    <th
      @click="toggleColumnView('maxLab')"
      :class="{ 'lab__contracted': headerView.contracted.maxLab }"
      class="header lab">
      <span class="title lab">MARCA</span>
    </th>
    <th
      @click="toggleColumnView('maxUnit')"
      :class="{ 'unit__contracted': headerView.contracted.maxUnit }"
      class="header unit">
      <span class="title unit">V. UNIT</span>
    </th>
    <th
      @click="toggleColumnView('maxTotal')"
      :class="{ 'total__contracted': headerView.contracted.maxTotal }"
      class="header total">
      <span class="title total">V. TOTAL</span>
    </th>
    <th class="header perc separator">
      <span class="title perc">%%</span>
    </th>

    <!-- ESTIMATED -->
    <th
      @click="toggleColumnView('estimatedUnit')"
      :class="{ 'unit__contracted': headerView.contracted.estimatedUnit }"
      class="header unit">
      <span class="title unit">V. UNIT</span>
    </th>
    <th
      @click="toggleColumnView('estimatedTotal')"
      :class="{ 'total__contracted': headerView.contracted.estimatedTotal }"
      class="header total">
      <span class="title total">V. TOTAL</span>
    </th>
    <th class="header perc separator">
      <span class="title perc">%%</span>
    </th>

    <!-- PROPOSAL -->
    <th
      @click="toggleColumnView('proposalUnit')"
      :class="{ 'unit__contracted': headerView.contracted.proposalUnit }"
      class="header unit">
      <span class="title unit">V. UNIT</span>
    </th>
    <th
      @click="toggleColumnView('proposalTotal')"
      :class="{ 'total__contracted': headerView.contracted.proposalTotal }"
      class="header total">
      <span class="title total">V. TOTAL</span>
    </th>
    <th class="header perc separator">
      <span class="title perc">%%</span>
    </th>

    <!-- MINIMUM -->
    <th
      @click="toggleColumnView('minimumUnit')"
      :class="{ 'unit__contracted': headerView.contracted.minimumUnit }"
      class="header unit">
      <span class="title unit">V. UNIT</span>
    </th>
    <th
      @click="toggleColumnView('minimumTotal')"
      :class="{ 'total__contracted': headerView.contracted.minimumTotal }"
      class="header total">
      <span class="title total">V. TOTAL</span>
    </th>
    <th class="header perc separator">
      <span class="title perc">%%</span>
    </th>

    <!-- RANKING -->
    <th
      @click="toggleColumnView('rankingDistributor')"
      :class="{ 'distributor__contracted': headerView.contracted.rankingDistributor }"
      class="header distributor">
      <span class="title distributor">DISTRIBUIDOR</span>
    </th>
    <th
      @click="toggleColumnView('rankingLab')"
      :class="{ 'lab__contracted': headerView.contracted.rankingLab }"
      class="header lab">
      <span class="title lab">MARCA</span>
    </th>
    <th
      @click="toggleColumnView('rankingUnit')"
      :class="{ 'unit__contracted': headerView.contracted.rankingUnit }"
      class="header unit">
      <span class="title unit">V. UNIT</span>
    </th>
    <th
      @click="toggleColumnView('rankingTotal')"
      :class="{ 'total__contracted': headerView.contracted.rankingTotal }"
      class="header total">  
      <span class="title total">V. TOTAL</span>
    </th>
    <th class="header perc separator">  
      <span class="title perc">%%</span>
    </th>
  </tr>
</template>

<script>
export default {
  name: 'ColumnHeader',
  data: () => ({
    headerView: {
      contracted: {
        costLab: false,
        costUnit: false,
        costTotal: false,
        maxLab: false,
        maxUnit: false,
        maxTotal: false,
        estimatedLab: false,
        estimatedUnit: false,
        estimatedTotal: false,
        proposalUnit: false,
        proposalTotal: false,
        minimumUnit: false,
        minimumTotal: false,
        rankingDistributor: false,
        rankingLab: false,
        rankingUnit: false,
        rankingTotal: false
      }
    }
  }),
  watch: {
    'headerView.contracted': {
      handler (v) {
        this.$emit('header-view-contraction', v)
      },
      deep: true
    }
  },
  methods: {
    toggleColumnView (column) {
      this.headerView.contracted[column] = !this.headerView.contracted[column]
    },
    toggleAllColumn (columns) {
      const newState = !this.headerView.contracted[columns[0]]
      for (const column in columns) {
        this.headerView.contracted[columns[column]] = newState
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/event-map/components/column-header/ColumnHeader.vue